import React from 'react';

import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';
import Button from '../../buttons/Button/Button';

import './ConditionCard.css';

const ConditionCard = ({ title, desc, image, link, serviceLink, leftDesc }) => {
  return (
    <div
      className='condition-card-container'
      style={{ backgroundImage: `url("${image}")` }}
    >
      <div id='condition-desc-container'>
        <h1 id='condition-title'>{title}</h1>
        {leftDesc && (
          <p id='condition-desc__left'>
            <LinkifiedText>{leftDesc}</LinkifiedText>
          </p>
        )}
        {link && <Button href={link}>Book Appointment</Button>}
      </div>
      <div id='condition-title-container'>
        <h1 id='condition-title'>{title}</h1>
      </div>
      <div id='condition-learn-more-container'>
        <span id='condition-learn-more'>Learn More</span>
      </div>
      {serviceLink && (
        <div className='service__btn'>
          <Button href={serviceLink}>Book Appointment</Button>
        </div>
      )}
    </div>
  );
};

export default ConditionCard;
